define([
    "./userPermissionsModule",
    "./userPermissionsRouter",
    "./UserPermissionsController",
    "./userPermissionsService",
    "./nlgMonitoringPermission"
], function () {
});